import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'
import { CustomTextField } from '../../../../../../shared/components/inputs'
import InputCountry from '../../../../../../shared/components/inputs/InputCountry'
import { IUser, ROLES } from '../../../../models/user'
import { UserBrand2Autocomplete } from '../../forms/UserBrand2Autocomplete'

interface WorkTabProps {
  user: IUser
  handleInputChange: (inputName: string, value: any) => void
}

export function WorkTab({ user, handleInputChange }: WorkTabProps) {
  const { t } = useTranslation(['global'])

  const { userSelected } = useSelector((state: IRootState) => state.user)

  return (
    <Grid container spacing={2}>
      {user.role_id !== ROLES.client && (
        <Grid xs={12} sm={6} md={user.role_id === ROLES.commercial ? 4 : 6}>
          <InputCountry
            value={user.countries}
            handleInputChange={handleInputChange}
            userSelected={userSelected !== null && user.id !== 0 ? userSelected : []}
            label={t('admin.people.manage-countries')}
          />
        </Grid>
      )}

      {[ROLES.commercialC, ROLES.commercialD].includes(user.role_id) && (
        <Grid xs={12} sm={6} md={6}>
          <CustomTextField inputName={'code'} value={user.code} handleInputChange={handleInputChange} />
        </Grid>
      )}

      {![ROLES.admin, ROLES.trainingManager].includes(user.role_id) && (
        <Grid xs={12} sm={6}>
          <UserBrand2Autocomplete user={user} userSelected={userSelected} handleInputChange={handleInputChange} />
        </Grid>
      )}
    </Grid>
  )
}
